import useHandleOrderFulfill from 'hooks/app-events/useHandleOrderFulfill';
import useHandleSubscribedSuccessfully from 'hooks/app-events/useHandleSubscribedSuccessfully';
import useProtobufServerSentEvents from 'hooks/useProtobufServerSentEvents';
import { SSE_PATHS } from 'services/sse/ssePaths';
import { Error as AppError, ErrorSchema } from '../../../pb/events/v1/error_pb';
import { InstallEvent, InstallEventSchema } from '../../../pb/events/v1/install_event_pb';
import { OrderFulfill, OrderFulfillSchema } from '../../../pb/events/v1/order_fulfill_pb';
import { SubscribedSuccessfully, SubscribedSuccessfullySchema } from '../../../pb/events/v1/subscribed_successfully_pb';
import { SubscriptionFailed, SubscriptionFailedSchema } from '../../../pb/events/v1/subscription_failed_pb';
import { DecodedSseEvent } from '../useProtobufServerSentEvents';

const APP_EVENT_SCHEMAS = [
    SubscribedSuccessfullySchema,
    SubscriptionFailedSchema,
    ErrorSchema,
    InstallEventSchema,
    OrderFulfillSchema,
];

export interface UseAppEventsOptions {
    enabled?: boolean;
}

export const useAppEvents = ({ enabled = true }: UseAppEventsOptions = {}) => {
    const { handleSubscribedSuccessfully } = useHandleSubscribedSuccessfully();
    const { handleOrderFulfill } = useHandleOrderFulfill();

    const handleSubscriptionFailed = (event: SubscriptionFailed) => {
        console.log('[AppEvent] SubscriptionFailed', event);
    };

    const handleError = (event: AppError) => {
        console.log('[AppEvent] Error', event);
    };

    const handleInstallEvent = (event: InstallEvent) => {
        console.log('[AppEvent] InstallEvent', event);
    };

    const handleMessage = (decoded: DecodedSseEvent) => {
        switch (decoded.typeName) {
            case SubscribedSuccessfullySchema.typeName:
                handleSubscribedSuccessfully(decoded.message as SubscribedSuccessfully);
                break;
            case SubscriptionFailedSchema.typeName:
                handleSubscriptionFailed(decoded.message as SubscriptionFailed);
                break;
            case ErrorSchema.typeName:
                handleError(decoded.message as AppError);
                break;
            case InstallEventSchema.typeName:
                handleInstallEvent(decoded.message as InstallEvent);
                break;
            case OrderFulfillSchema.typeName:
                handleOrderFulfill(decoded.message as OrderFulfill);
                break;
            default:
                console.warn('[AppEvent] Unknown event type:', decoded.typeName, decoded.raw);
        }
    };

    useProtobufServerSentEvents({
        path: SSE_PATHS.APP_EVENTS,
        schemas: APP_EVENT_SCHEMAS,
        enabled,
        onMessage: handleMessage,
        onError: (error) => console.warn('[AppEvent] SSE error', error),
    });
};

export default useAppEvents;
